import { render, staticRenderFns } from "./ExternalVenueDetails.vue?vue&type=template&id=a1bcb1d2&scoped=true&"
import script from "./ExternalVenueDetails.vue?vue&type=script&lang=ts&"
export * from "./ExternalVenueDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalVenueDetails.vue?vue&type=style&index=0&id=a1bcb1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bcb1d2",
  null
  
)

export default component.exports